import * as React from "react";
import {connect} from 'react-redux';

import {setTitle} from '../../actions/topHeaderActions';
import GlobalSearchGrid from '../../components/bo-core/grids/GlobalSearchGrid';
import {fetchAllTags} from "../../actions/boCoreActions";
import LoadingModal from "../../components/bo-core/modals/LoadinModal";

interface Props {
    fetchAllTags(callBack?: any): void;

    setTitle(title: string): void;
}

interface State {
    isLoading: boolean;
}

class GlobalSearch extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            isLoading: true
        }
    }

    UNSAFE_componentWillMount(): void {
        this.props.fetchAllTags(() => {
            this.setState({isLoading: false});
        });
    }

    componentDidMount() {
        this.props.setTitle("Global Search");
    };

    componentWillUnmount() {
        this.props.setTitle("");
    };

    render() {
        if (this.state.isLoading) {
            return <LoadingModal open={true}/>
        }
        return (
            <div style={{height: "100%", minHeight: 400}} className="bo-core">
                <GlobalSearchGrid/>
            </div>
        )
    }
}

const mapStateToProps = () => {
    return {}
};

const mapDispatchToProps = (dispatch) => {
    return {
        fetchAllTags: (callBack?: any) => {
            dispatch(fetchAllTags(callBack));
        },
        setTitle: (title) => {
            dispatch(setTitle(title))
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(GlobalSearch)



// WEBPACK FOOTER //
// ./app/views/bo-core/GlobalSearch.tsx